<template>
  <div class="p-6 lg:px-8 lg:pt-4 lg:pb-8" aria-busy="true" aria-live="polite">
    <!-- Carrito (step 3) -->
    <template v-if="variant === 'cart'">
      <div class="h-14 bg-light-gray rounded-xl animate-pulse mb-4" />
      <div class="h-5 bg-light-gray rounded animate-pulse mb-6 max-w-sm mx-auto" />
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-3 lg:gap-4">
        <div
          v-for="i in 2"
          :key="i"
          class="h-24 bg-light-gray rounded-lg border border-light-gray animate-pulse"
          :style="{ animationDelay: `${i * 100}ms` }"
        />
      </div>
      <div class="mt-6 flex flex-col gap-3">
        <div class="h-10 w-full bg-light-gray rounded-lg animate-pulse" />
        <div class="h-12 w-full bg-light-gray rounded-lg animate-pulse" />
      </div>
    </template>

    <!-- Suscripción (step 2) -->
    <template v-else-if="variant === 'subscriptions'">
      <div class="h-14 bg-light-gray rounded-xl animate-pulse mb-4" />
      <div class="h-5 bg-light-gray rounded animate-pulse mb-6 max-w-md mx-auto" />
      <div class="flex gap-2 overflow-x-hidden pb-1 mb-4 -mx-1 px-1">
        <div
          v-for="i in 4"
          :key="i"
          class="h-9 w-24 shrink-0 bg-light-gray rounded-lg animate-pulse"
          :style="{ animationDelay: `${i * 80}ms` }"
        />
      </div>
      <div class="h-6 w-40 bg-light-gray rounded animate-pulse mb-4" />
      <div class="space-y-3">
        <div
          v-for="i in 3"
          :key="i"
          class="h-20 bg-light-gray rounded-lg border border-light-gray animate-pulse"
          :style="{ animationDelay: `${i * 120}ms` }"
        />
      </div>
      <div class="h-12 w-full bg-light-gray rounded-lg animate-pulse mt-6" />
    </template>

    <!-- Pago (step 4) -->
    <template v-else-if="variant === 'payment'">
      <div class="h-14 bg-light-gray rounded-xl animate-pulse mb-4" />
      <div class="h-5 bg-light-gray rounded animate-pulse mb-6 max-w-md mx-auto" />
      <div class="h-12 w-full bg-light-gray rounded-lg border border-light-gray animate-pulse mb-4" />
      <div class="space-y-3">
        <div class="h-4 w-24 bg-light-gray rounded animate-pulse" />
        <div class="h-10 w-full bg-light-gray rounded-lg animate-pulse" />
        <div class="h-4 w-32 bg-light-gray rounded animate-pulse mt-2" />
        <div class="h-10 w-full bg-light-gray rounded-lg animate-pulse" />
      </div>
      <div class="h-12 w-full bg-light-gray rounded-lg animate-pulse mt-6" />
    </template>

    <!-- Perfil (step 1) -->
    <template v-else-if="variant === 'profile'">
      <div class="h-6 w-48 bg-light-gray rounded animate-pulse mx-auto mb-6" />
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-3 lg:gap-4">
        <div
          v-for="i in 6"
          :key="i"
          class="space-y-1"
        >
          <div class="h-3 w-20 bg-light-gray rounded animate-pulse" />
          <div class="h-10 bg-light-gray rounded-lg animate-pulse" />
        </div>
      </div>
      <div class="mt-6 flex flex-col gap-3 sm:flex-row">
        <div class="h-11 flex-1 bg-light-gray rounded-lg animate-pulse" />
        <div class="h-11 flex-1 bg-light-gray rounded-lg animate-pulse" />
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    name: "StepLoadingSkeleton",
    props: {
      variant: {
        type: String,
        default: "cart",
        validator: (v) =>
          ["cart", "subscriptions", "payment", "profile"].includes(v),
      },
    },
  };
</script>
